var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.serviceProviders),function(serviceProvider){return _c('v-list-item',{key:serviceProvider.uid},[_c('v-list-item-content',[_vm._v(_vm._s(serviceProvider.title))]),_c('v-list-item-action',[_c('v-btn',{attrs:{"fab":"","icon":"","to":{
          name: 'serviceproviders/details',
          params: { uid: serviceProvider.uid }
        }}},[_c('v-icon',[_vm._v("folder")])],1)],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }